import React, { Suspense, lazy } from 'react'

const PageBuilder = ({ id, data, auxData, dataFallback }) => {
    const pageContent = []
    const { modules } = data.content

    Object.entries(modules).map(([key, module]) => {
        const firstModule = (key === '0') ? true : false;
        const RenderedModule = lazy(() => import(`../modules/${module.module}`))
        pageContent.push(
            <RenderedModule key={`pb_${id}_${key}`} options={module} firstModule={firstModule} data={data} auxData={auxData} />,
        )
        return true
    })


    return (
        <Suspense fallback={dataFallback}>
            {pageContent}
        </Suspense>
    )
}

export default PageBuilder
